import './individual-info-step.scss';
import { IconBtn } from '@ru-digital-assets/ui-component';
import { useHistory } from 'react-router';
import { useCallback } from 'react';
import { SIGNUP_PATHS } from 'constants/constants';
import UserIcon from 'assets/icons/user';
import UiInput from 'modules/ui/ui-input/ui-input';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useAppDispatch } from 'store';
import { setProfileInfo } from 'store/actions/signup';

interface IndividualInfoFormState {
  name: string;
  secondName: string;
  lastName: string;
  inn: string;
  email: string;
  address: string;
}

const formInitialState: IndividualInfoFormState = {
  name: '',
  secondName: '',
  lastName: '',
  inn: '',
  email: '',
  address: '',
};

export const ValidationSchema = yup.object().shape({
  name: yup.string().trim().required(),
  lastName: yup.string().trim().required(),
  inn: yup.string().trim().length(10).required(),
  email: yup.string().trim().email().required(),
  address: yup.string().trim().required(),
});

export default function IndividualInfoStep() {
  const dispatch = useAppDispatch();

  const history = useHistory();

  const onCancel = useCallback(() => {
    history.replace(SIGNUP_PATHS.PERSON_SELECT);
  }, []);

  const formState = useFormik({
    initialValues: formInitialState,
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: ValidationSchema,
    onSubmit: (values) => {
      const fullName =
        values.lastName +
        ' ' +
        values.name +
        (values.secondName ? ' ' + values.secondName : '');

      dispatch(
        setProfileInfo({
          fullName,
          email: values.email,
          position: "-",
          company: {
            tin: values.inn,
            address: values.address,
            fullName: '-',
            shortName: '-',
            ogrn: '-',
            kpp: '-',
            postalAddress: '-',
          },
        })
      ).then((action) => {
        if (action.meta.requestStatus === 'fulfilled') {
          history.push(SIGNUP_PATHS.DOCS);
        }
      });
    },
  });

  return (
    <div className="individual-info-step">
      <p className="p p_font-size_32 mb_24 p_weight_300">Регистрация</p>
      <p className="p p_bold p_font-size_18 mb_24">Ваши данные:</p>
      <div className="individual-info-step__row mb_16">
        <div>
          <UiInput
            name="lastName"
            onChange={formState.handleChange}
            onInputBlur={formState.handleBlur}
            error={formState.errors.lastName}
            lg
            label="Фамилия"
          />
          {formState.errors.lastName && (
            <p className="p p_error mt_4">Поле не может быть пустым</p>
          )}
        </div>
        <div>
          <UiInput
            name="name"
            onChange={formState.handleChange}
            onInputBlur={formState.handleBlur}
            error={formState.errors.name}
            lg
            label="Имя"
          />
          {formState.errors.name && (
            <p className="p p_error mt_4">Поле не может быть пустым</p>
          )}
        </div>
      </div>
      <UiInput
        name="secondName"
        onChange={formState.handleChange}
        onInputBlur={formState.handleBlur}
        className="mb_16"
        lg
        label="Отчество (если есть)"
      />
      <div className="individual-info-step__row mb_16">
        <div>
          <UiInput
            name="inn"
            onChange={formState.handleChange}
            onInputBlur={formState.handleBlur}
            error={formState.errors.inn}
            lg
            label="ИНН"
          />
          {formState.errors.inn && (
            <p className="p p_error mt_4">Поле должно содержать 10 цифр</p>
          )}
        </div>
        <div>
          <UiInput
            name="email"
            onChange={formState.handleChange}
            onInputBlur={formState.handleBlur}
            error={formState.errors.email}
            lg
            label="Email"
          />
          {formState.errors.email && (
            <p className="p p_error mt_4">Введите корректный Email</p>
          )}
        </div>
      </div>
      <div className="mb_32">
        <UiInput
          name="address"
          onChange={formState.handleChange}
          onInputBlur={formState.handleBlur}
          error={formState.errors.address}
          lg
          label="Адрес регистрации по месту жительства"
        />
        {formState.errors.address && (
          <p className="p p_error mt_4">Поле не может быть пустым</p>
        )}
      </div>
      <div className="flex align-center">
        <IconBtn
          title="Продолжить"
          icon={<UserIcon width={20} height={20} color="#fff" />}
          onClick={() => formState.handleSubmit()}
        />
        <button className="button button_primary ml_24" onClick={onCancel}>
          Назад
        </button>
      </div>
    </div>
  );
}
